import { ICommentResource } from "../../comments";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";

export type ICommentEditMutationParameters = {
    comment: RelationalValue<ICommentResource>;
};

export type ICommentEditMutationResult = ICommentResource;

export const commentEditMutation: IApiMutationFunction<ICommentEditMutationParameters> = ({ comment }) => {
    return {
        method: "PATCH",
        url: `/comments/${mapRelationalValue(comment)}`,
        data: comment,
        headers: {
            "Content-Type": "application/merge-patch+json",
        },
    };
};

export const useCommentEditMutation = createApiMutationHook<ICommentEditMutationParameters, ICommentEditMutationResult>(
    commentEditMutation,
);
